export enum EnvironmentValuesEnum {
  Local = 'local',
  Development = 'development',
  Quality = 'qua',
  Acceptance = 'acceptance',
  Hypercare = 'hypercare',
  Production = 'production',
}
